export const allPlanningCategories = [
  // Core building works
  'conversions',
  'extensions',
  'new-build',
  'exterior-finish',
  'balconies',
  'structural-alterations',
  'roofing',
  'internal-refurbishments',

  // Fit-out / specialist internal works
  'kitchens',
  'bathrooms',
  'changing-rooms',
  'laundry-facilities',
  'lighting',

  // Envelope / frontage / external features
  'glazing',
  'shop-fronts',

  // Site / utility works
  'groundworks',
  'landscaping',
  'drainage',
  'fencing-boundaries',
  'sewage-treatment',

  // Recreational facilities
  'indoor-play-areas',
  'outdoor-play-areas',
  'swimming-pools',
  'skate-parks',
  'sports-fields',
  'sports-courts',
  'pavilions',

  // Renewables
  'renewables-solar',
  'renewables-ev-charging',
  'renewables-heat-pump',
  'renewables-battery-storage',
] as const

export type PlanningCategory = (typeof allPlanningCategories)[number]
